export type Sticker = {
  sticker_id: string
  product_id: string

  title: string
  description: string
  priority: number
  full_price_uah: number
  discounted_price_uah: number
  payment_description: string
}

const BASE_URL = "https://german.ntbooks.pro"

export async function fetchStickers(): Promise<Sticker[]> {

  const res = await fetch(
    `${BASE_URL}/wp-json/edu/v6/stickers`
  )

  if (!res.ok) {
    throw new Error("Failed to load stickers")
  }

  return res.json()
}